import React from "react";
import { useNavigate } from "react-router-dom";
import {
  LayoutDashboard, LayoutGrid, Workflow, Users, Wallet, LogOut, FileSpreadsheet, Bot,
} from "lucide-react";
import { useApp } from "@/context/AppContext";

const NAV = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "directory", label: "Service Directory", icon: LayoutGrid },
  { key: "workspaces", label: "My Workspaces", icon: Workflow },
  { key: "prospecting", label: "Prospecting Agent", icon: Bot },
  { key: "generator", label: "Invoice Generator", icon: FileSpreadsheet },
  { key: "leads", label: "Leads Portal", icon: Users },
  { key: "wallet", label: "Wallet & Billing", icon: Wallet },
];

export default function Sidebar({ active }) {
  const navigate = useNavigate();
  const { profile, wallet, logout } = useApp();

  const go = (key) => navigate(`/app/${key}`);

  return (
    <aside className="hidden md:flex flex-col w-72 h-full glass-nav border-r border-white/10 flex-shrink-0">
      <div className="px-6 py-6 border-b border-white/10">
        <div className="text-2xl font-extrabold tracking-tight font-display cursor-pointer" onClick={() => navigate("/")}>
          DONDR<span className="text-primary-400">Á</span>E
        </div>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto hide-scrollbar">
        {NAV.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.key;
          return (
            <button
              key={item.key}
              onClick={() => go(item.key)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all ${
                isActive
                  ? "bg-primary-600/20 text-white border border-primary-500/30 shadow-[0_0_15px_rgba(59,130,246,0.15)]"
                  : "text-zinc-400 hover:text-white hover:bg-white/5 border border-transparent"
              }`}
            >
              <Icon size={18} className={isActive ? "text-primary-400" : ""} />
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="px-4 py-4 border-t border-white/10 space-y-3">
        <div className="px-4 py-3 rounded-xl bg-black/40 border border-white/5">
          <div className="text-[10px] font-bold text-zinc-500 uppercase tracking-wider">Wallet Balance</div>
          <div className="text-lg font-bold text-green-400">${(wallet?.balance ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</div>
        </div>
        <div className="flex items-center gap-3 px-2">
          <div className="w-9 h-9 rounded-full bg-primary-900/60 border border-primary-500/40 flex items-center justify-center text-primary-300 font-bold text-sm">
            {profile?.contact_name?.[0]?.toUpperCase() || "U"}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-bold text-white truncate">{profile?.business_name || "My Business"}</div>
            <div className="text-xs text-zinc-500 truncate">{profile?.email}</div>
          </div>
          <button onClick={() => { logout(); navigate("/"); }} className="text-zinc-500 hover:text-red-400 transition-colors" title="Sign out">
            <LogOut size={18} />
          </button>
        </div>
      </div>
    </aside>
  );
}
